"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var LogoStyles = _interopRequireWildcard(require("./LogoStyles"));
var _Close = _interopRequireDefault(require("@mui/icons-material/Close"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _object = require("../../utils/type-checks/object");
var _styles = require("@mui/material/styles");
var _material = require("@mui/material");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const merge = require("deepmerge");

/**
 * Logo and close button for mobile navigation menu drawers
 *
 * @visibleName Mobile Navigation -  Logo
 * @author [Jeff Stevens](mailto:jeffrey.stevens@pheaa.org)
*/
const Logo = props => {
  if (!(0, _object.isObject)(window.PubSub)) {
    window.PubSub = require("pubsub-js");
  }
  const {
      customCloseButtonStyles = {},
      customCloseIconStyles = {},
      customLogoStyles = {},
      customTheme = {},
      logo,
      testId
    } = props,
    theme = merge((0, _styles.useTheme)(), customTheme),
    logoClasses = (0, _classnames.default)({
      "mobile-logo": true
    }),
    closeButtonStyles = merge(LogoStyles.CloseButtonStyles(theme), customCloseButtonStyles),
    closeIconStyles = merge(LogoStyles.CloseIconStyles(theme), customCloseIconStyles),
    logoStyles = merge(LogoStyles.LogoStyles(theme), customLogoStyles),
    onClick = () => {
      window.PubSub.publish("navigation.mobile.close");
    };
  return /*#__PURE__*/_react.default.createElement(_material.Card, {
    className: logoClasses,
    "data-testid": testId,
    sx: logoStyles
  }, /*#__PURE__*/_react.default.createElement(_material.CardMedia, {
    alt: logo.alt,
    className: "mobile-logo__image",
    component: "img",
    src: logo.src
  }), /*#__PURE__*/_react.default.createElement(_material.Button, {
    className: "mobile-logo__close-icon",
    "data-testid": `${testId}__close-button`,
    onClick: onClick,
    sx: closeButtonStyles,
    title: "Close Menu"
  }, /*#__PURE__*/_react.default.createElement(_Close.default, {
    height: closeIconStyles.height,
    width: closeIconStyles.width,
    sx: closeIconStyles
  })));
};
Logo.propTypes = {
  /** Custom style object for close button (Default Value: {}) */
  customCloseButtonStyles: _propTypes.default.object,
  /** Custom style object for close button icon (Default Value: {}) */
  customCloseIconStyles: _propTypes.default.object,
  /** Custom style object for logo image (Default Value: {}) */
  customLogoStyles: _propTypes.default.object,
  /** Theme injection object (Default Value: {}) */
  customTheme: _propTypes.default.object,
  /** Object describing logo image attributes */
  logo: _propTypes.default.shape({
    /** Alt. Description for image */
    alt: _propTypes.default.string.isRequired,
    /** URL for Image */
    src: _propTypes.default.string.isRequired
  }).isRequired,
  /** @ignore */
  testId: _propTypes.default.string
};
var _default = exports.default = Logo;